var L = Object.defineProperty;
var T = (i, t, e) => t in i ? L(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var p = (i, t, e) => T(i, typeof t != "symbol" ? t + "" : t, e);
import { FieldDirectiveEnum as u } from "../../app/field/types/index.js";
import { GenericTypeMutationInputBuilder as F } from "../../app/api/generic-type-mutation-input-builder.js";
import { equalsWhenLowerCased as f, isNotNil as j, idFromObjectName as y } from "../../shared/utils.js";
import { StepParamsOneOfSchemaHandler as E } from "./step-params-one-of-schema-handler.js";
import { F as a } from "../../index-gVtEopq1.js";
const C = (i, t) => {
  var e, n;
  switch (i.type) {
    case a.Boolean:
      return {
        type: "boolean",
        originalPath: ["fields", i.name]
      };
    case a.Integer:
      return {
        type: "integer",
        originalPath: ["fields", i.name]
      };
    case a.Json:
      return {
        type: "object",
        originalPath: ["fields", i.name]
      };
    case a.Float:
      return {
        type: "number",
        originalPath: ["fields", i.name]
      };
    case a.ListBoolean:
      return {
        type: "array",
        items: {
          type: "boolean"
        },
        originalPath: ["fields", i.name]
      };
    case a.ListInteger:
      return {
        type: "array",
        items: {
          type: "integer"
        },
        originalPath: ["fields", i.name]
      };
    case a.ListFloat:
      return {
        type: "array",
        items: {
          type: "number"
        },
        originalPath: ["fields", i.name]
      };
    case a.ListId:
    case a.ListString:
      return {
        type: "array",
        items: {
          type: "string"
        },
        originalPath: ["fields", i.name]
      };
    case a.Time:
    case a.Timestamp:
    case a.IpAddress:
    case a.Phone:
    case a.Email:
    case a.Url:
    case a.ID:
    case a.Date:
    case a.DateTime:
    case a.String:
      return {
        type: "string",
        originalPath: ["fields", i.name]
      };
    // Handles the enum case
    default:
      return {
        type: "string",
        enum: (n = (e = t.enums) == null ? void 0 : e.find(
          (r) => r.name === i.type
        )) == null ? void 0 : n.values,
        originalPath: ["fields", i.name]
      };
  }
}, I = (i, t) => {
  var s, c, l, m;
  const e = (s = i.types) == null ? void 0 : s.find(
    (d) => f(d.name, t.parents.first ?? "")
  ), n = (c = i.types) == null ? void 0 : c.find(
    (d) => f(d.name, t.parents.second ?? "")
  ), r = ((l = e == null ? void 0 : e.fields.find(
    (d) => d.directives.includes(u.CONNECTOR)
  )) == null ? void 0 : l.name) ?? "id", o = ((m = n == null ? void 0 : n.fields.find(
    (d) => d.directives.includes(u.CONNECTOR)
  )) == null ? void 0 : m.name) ?? "id";
  return {
    first: {
      parentTypeName: e == null ? void 0 : e.name,
      parentTypeId: e == null ? void 0 : e.id,
      connector: r,
      fieldName: e && r && y(e.name, r)
    },
    second: {
      parentTypeName: n == null ? void 0 : n.name,
      parentTypeId: n == null ? void 0 : n.id,
      connector: o,
      fieldName: n && o && y(n.name, o)
    }
  };
}, O = (i, t, e) => {
  var o;
  const n = (o = e.types) == null ? void 0 : o.find(
    (s) => s.id.toLowerCase() === i.toLowerCase()
  );
  if (!n)
    return [];
  const r = I(e, n);
  return n.fields.filter((s) => !t.includes(s.name)).concat(
    [r.first.fieldName, r.second.fieldName].filter(j).map((s) => ({
      name: s,
      type: a.ID,
      directives: []
    }))
  );
}, h = (i, t, e) => Object.fromEntries(
  O(i, t, e).map(
    (n) => [n.name, C(n, e)]
  )
);
class U {
  constructor(t, e) {
    p(this, "apiDeclaration");
    p(this, "fieldExcludeList");
    p(this, "oneOfSchemaHandler");
    p(this, "isGenericTypeStepHandler", !0);
    var s;
    const n = ["id", "createdAt", "updatedAt", "ofType"], r = [
      "ofType",
      "fields",
      "namespace",
      "directives",
      "connections"
    ], o = {
      oneOf: ((s = e.types) == null ? void 0 : s.map((c) => ({
        type: "object",
        properties: {
          ...t.properties,
          ...h(
            c.id,
            n,
            e
          ),
          ofType: {
            type: "string",
            enum: [c.id]
          }
        },
        required: [
          ...t.required ?? [],
          ...O(
            c.id,
            n,
            e
          ).filter(
            (l) => l.directives.includes(u.REQUIRED)
          ).map((l) => l.name)
        ]
      }))) ?? [],
      routingParams: ["ofType"]
    };
    this.oneOfSchemaHandler = new E(
      o,
      r,
      !1,
      (c) => c.ofType
    ), this.apiDeclaration = e, this.fieldExcludeList = n;
  }
  getFieldLogicLanguage(t, e) {
    return this.oneOfSchemaHandler.getFieldLogicLanguage(t, e);
  }
  getFieldLogicLanguageOptions(t, e) {
    return this.oneOfSchemaHandler.getFieldLogicLanguageOptions(
      t,
      e
    );
  }
  get schema() {
    return this.oneOfSchemaHandler.schema;
  }
  getFields(t) {
    return this.oneOfSchemaHandler.getFields(t);
  }
  validate(t) {
    return this.oneOfSchemaHandler.validate(t);
  }
  getUpdatedState(t, e, n) {
    var g;
    if (e === "ofType")
      return {
        namespace: "",
        ofType: n,
        fields: {}
      };
    const r = t.ofType;
    if (!r || !((g = this.apiDeclaration.types) == null ? void 0 : g.find(
      (S) => f(S.id, r)
    )))
      return t;
    const s = h(
      r,
      this.fieldExcludeList,
      this.apiDeclaration
    ), c = this.oneOfSchemaHandler.getUpdatedState(
      t,
      e,
      n
    ), {
      ["Object.fromEntries"]: l,
      object: m,
      ...d
    } = c.fields, b = e in s ? {
      // Migration of the fields object from the old format to the new one
      ...l ? Object.fromEntries(l) : {},
      ...m ? Object.fromEntries(m) : {},
      ...d
    } : d;
    return {
      ...new F(
        this.apiDeclaration
      ).getMutationInput(c),
      fields: b
    };
  }
  getUpdatedParamsConfigState(t, e, n, r) {
    const o = {
      type: "object",
      subParams: {
        first: {
          type: "logic",
          language: "static"
        },
        second: {
          type: "logic",
          language: "static"
        }
      }
    }, s = {
      type: "object",
      subParams: {
        sortby: {
          type: "logic",
          language: "static"
        }
      }
    };
    return n === "ofType" ? {
      fields: {
        type: "object",
        subParams: {}
      },
      connections: o,
      directives: s
    } : {
      ...this.oneOfSchemaHandler.getUpdatedParamsConfigState(
        t,
        e,
        n,
        r
      ),
      connections: o,
      directives: s
    };
  }
  getFieldValue(t, e) {
    return this.oneOfSchemaHandler.getFieldValue(t, e);
  }
  getInitialState(t, e) {
    const n = e && "isGenericTypeStepHandler" in e ? e.getOfTypeValue(t) : void 0;
    return {
      namespace: "",
      ...n && { ofType: n },
      fields: {}
    };
  }
  getOfTypeValue(t) {
    return t.ofType;
  }
}
export {
  U as GenericTypeStepMutationHandler,
  O as objectDeclarationFields,
  h as objectDeclarationToProperties
};
